// src/componentes/Cuerpos/submoduloscomunes/ProveedorModal/ProveedorModal.jsx

import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import PuenteApi from '../../../../pageauth/PuenteApi';
import Cargando from '../../../../Cargando';
import { FaSearch, FaPlus } from 'react-icons/fa';
import Swal from 'sweetalert2';

// Custom styles for specific UI elements in this modal
const modalStyles = `
    .border-dashed {
        border-style: dashed !important;
    }
    .hover-bg-light:hover {
        background-color: #f8f9fa !important;
    }
    .transition-all {
        transition: all 0.2s ease-in-out;
    }
    .pointer-events-none {
        pointer-events: none;
    }
`;

const ProveedorModal = ({ isVisible, onClose, SetMensaje, proveedorToEdit = null, endpoint }) => {

    const { ObtenerDatosDeCuitArca, CrearProvedor, ActualizarProvedor, ObtenerProvedoresFamilias, CrearProvedorFamilia } = PuenteApi()
    const { StartCargando, StopCargando } = Cargando()

    const [codigo, setCodigo] = useState('');
    const [cuit, setCuit] = useState('');
    const [razonSocial, setRazonSocial] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [domicilio, setDomicilio] = useState('');
    const [provincia, setProvincia] = useState('');
    const [localidad, setLocalidad] = useState('');
    const [cp, setCp] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [condicionIva, setCondicionIva] = useState('Responsable Inscripto');
    const [cuentaCorriente, setCuentaCorriente] = useState(false);
    const [exento, setExento] = useState(false);
    const [convenio, setConvenio] = useState(false);
    const [iva, setIva] = useState(false);
    const [observaciones, setObservaciones] = useState('');

    // Familias
    const [familiasDisponibles, setFamiliasDisponibles] = useState([]);
    const [familiasSeleccionadas, setFamiliasSeleccionadas] = useState([]);
    const [busquedaFamilia, setBusquedaFamilia] = useState('');

    useEffect(() => {
        if (isVisible) {
            cargarFamilias();
            setBusquedaFamilia('');
            if (proveedorToEdit) {
                setCodigo(proveedorToEdit.codigo || '');
                setCuit(proveedorToEdit.cuit || '');
                setRazonSocial(proveedorToEdit.razon_social || '');
                setDescripcion(proveedorToEdit.descripcion || '');
                setDomicilio(proveedorToEdit.domicilio || '');
                setProvincia(proveedorToEdit.provincia || '');
                setLocalidad(proveedorToEdit.localidad || '');
                setCp(proveedorToEdit.cp || '');
                setEmail(proveedorToEdit.email || '');
                setTelefono(proveedorToEdit.telefono || '');
                setCondicionIva(proveedorToEdit.condicion_iva || 'Responsable Inscripto');
                setCuentaCorriente(!!proveedorToEdit.cuenta_corriente);
                setExento(!!proveedorToEdit.exento);
                setConvenio(!!proveedorToEdit.convenio);
                setIva(!!proveedorToEdit.iva);
                setObservaciones(proveedorToEdit.observaciones || '');
                setFamiliasSeleccionadas(proveedorToEdit.familias || []);
            } else {
                setCodigo('');
                setCuit('');
                setRazonSocial('');
                setDescripcion('');
                setDomicilio('');
                setProvincia('');
                setLocalidad('');
                setCp('');
                setEmail('');
                setTelefono('');
                setCondicionIva('Responsable Inscripto');
                setCuentaCorriente(false);
                setExento(false);
                setConvenio(false);
                setIva(false);
                setObservaciones('');
                setFamiliasSeleccionadas([]);
            }
        }
    }, [isVisible, proveedorToEdit]);

    const cargarFamilias = async () => {
        const families = await ObtenerProvedoresFamilias(endpoint);
        setFamiliasDisponibles(families);
    }

    const handleGuardar = async (e) => {
        e.preventDefault();

        const proveedorData = {
            codigo,
            cuit,
            razon_social: razonSocial,
            descripcion,
            domicilio: domicilio || null,
            provincia: provincia || null,
            localidad: localidad || null,
            cp: cp || null,
            email: email || null,
            telefono,
            condicion_iva: condicionIva,
            cuenta_corriente: cuentaCorriente,
            exento,
            convenio,
            iva,
            observaciones,
            familias: familiasSeleccionadas
        };

        StartCargando("Guardando", "Guardando proveedor", 3000);
        let resultado;
        if (proveedorToEdit) {
            resultado = await ActualizarProvedor(endpoint, proveedorToEdit.id, proveedorData);
        } else {
            resultado = await CrearProvedor(endpoint, proveedorData);
        }

        if (resultado === true) {
            StopCargando();
            SetMensaje("OK", `Proveedor ${proveedorToEdit ? 'actualizado' : 'guardado'} exitosamente`, 3000);
            onClose();
        } else {
            StopCargando();
        }
    };

    const buscar_datos_arca = async (e) => {
        e.preventDefault();
        if (cuit.length !== 11) {
            SetMensaje("Error", "CUIT inválido", 3000);
            return;
        }
        StartCargando("Buscando", "Buscando en ARCA", 3000);
        const res = await ObtenerDatosDeCuitArca(cuit);
        StopCargando();
        if (res.success) {
            setRazonSocial(res.dato.personaReturn.persona.razonSocial || '');
            setDomicilio(res.dato.personaReturn.persona.domicilio[0].direccion || '');
            setProvincia(res.dato.personaReturn.persona.domicilio[0].descripcionProvincia || '');
            setLocalidad(res.dato.personaReturn.persona.domicilio[0].localidad || '');
            setCp(res.dato.personaReturn.persona.domicilio[0].codigoPostal || '');
            setCondicionIva(res.dato.personaReturn.persona.condicionIva || 'Responsable Inscripto');
            SetMensaje("OK", "Datos obtenidos de ARCA", 3000);
        }
    };

    const handleFamiliaChange = (familiaId) => {
        if (familiasSeleccionadas.includes(familiaId)) {
            setFamiliasSeleccionadas(familiasSeleccionadas.filter(id => id !== familiaId));
        } else {
            setFamiliasSeleccionadas([...familiasSeleccionadas, familiaId]);
        }
    }

    const agregarNuevaFamilia = async () => {
        const { value: formValues } = await Swal.fire({
            title: 'Nueva Familia de Proveedor',
            html:
                '<input id="swal-input1" class="swal2-input" placeholder="Código">' +
                '<input id="swal-input2" class="swal2-input" placeholder="Nombre">' +
                '<input id="swal-input3" class="swal2-input" placeholder="Descripción">',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                return {
                    codigo: document.getElementById('swal-input1').value,
                    nombre: document.getElementById('swal-input2').value,
                    descripcion: document.getElementById('swal-input3').value
                }
            }
        });

        if (formValues) {
            if (!formValues.codigo || !formValues.nombre) {
                SetMensaje("Error", "Código y Nombre son requeridos", 3000);
                return;
            }
            StartCargando("Guardando", "Creando familia", 3000);
            const res = await CrearProvedorFamilia(endpoint, formValues);
            StopCargando();
            if (res) {
                SetMensaje("OK", "Familia creada correctamente", 3000);
                cargarFamilias();
            }
        }
    }

    const familiasFiltradas = familiasDisponibles.filter(f => {
        const busquedaFinal = (busquedaFamilia || "").toLowerCase();
        const nombre = (f.nombre || "").toLowerCase();
        const codigo = (f.codigo || "").toLowerCase();
        return nombre.includes(busquedaFinal) || codigo.includes(busquedaFinal);
    });

    return (
        <Modal
            show={isVisible}
            onHide={onClose}
            size="lg"
            centered
            scrollable
            enforceFocus={false} // Required for SweetAlert inputs inside Bootstrap Modal
        >
            <style>{modalStyles}</style>
            <Modal.Header closeButton>
                <Modal.Title className="text-primary fw-bold">
                    {proveedorToEdit ? 'Editar Proveedor Global' : 'Nuevo Proveedor Global'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light">
                <Form onSubmit={handleGuardar}>
                    <div className="card shadow-sm mb-4 border-0">
                        <div className="card-header bg-white py-3 border-bottom">
                            <h5 className="mb-0 text-secondary">Información Principal</h5>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6 border-end">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-bold">CUIT</Form.Label>
                                        <div className="d-flex gap-2">
                                            <Form.Control type="text" value={cuit} onChange={(e) => setCuit(e.target.value)} required placeholder="Sin guiones" className="shadow-none border-1" />
                                            <Button variant="outline-primary" onClick={buscar_datos_arca} title="Validar en AFIP/ARCA">
                                                <FaSearch />
                                            </Button>
                                        </div>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-bold">Razón Social</Form.Label>
                                        <Form.Control type="text" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} required placeholder="Ej: Tech Solutions S.A." className="shadow-none" />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-bold">Código Interno</Form.Label>
                                        <Form.Control type="text" value={codigo} onChange={(e) => setCodigo(e.target.value)} required placeholder="P-001" className="shadow-none" />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-bold">Condición IVA</Form.Label>
                                        <Form.Select value={condicionIva} onChange={(e) => setCondicionIva(e.target.value)} className="shadow-none">
                                            <option value="Responsable Inscripto">Responsable Inscripto</option>
                                            <option value="Monotributista">Monotributista</option>
                                            <option value="Exento">Exento</option>
                                            <option value="Consumidor Final">Consumidor Final</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <div className="card bg-white p-3 mb-0 border shadow-none rounded-3">
                                        <Form.Check type="switch" label="Cuenta Corriente" checked={cuentaCorriente} onChange={(e) => setCuentaCorriente(e.target.checked)} className="mb-1" />
                                        <Form.Check type="checkbox" label="Exento Percepciones" checked={exento} onChange={(e) => setExento(e.target.checked)} className="mb-1" />
                                        <Form.Check type="checkbox" label="Convenio Multilateral" checked={convenio} onChange={(e) => setConvenio(e.target.checked)} className="mb-1" />
                                        <Form.Check type="checkbox" label="Percepción IVA" checked={iva} onChange={(e) => setIva(e.target.checked)} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-bold">Email</Form.Label>
                                        <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="proveedor@empresa.com" className="shadow-none" />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-bold">Teléfono</Form.Label>
                                        <Form.Control type="text" value={telefono} onChange={(e) => setTelefono(e.target.value)} placeholder="+54 9..." className="shadow-none" />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-bold">Domicilio</Form.Label>
                                        <Form.Control type="text" value={domicilio} onChange={(e) => setDomicilio(e.target.value)} placeholder="Calle 123" className="shadow-none" />
                                    </Form.Group>
                                    <div className="row">
                                        <div className="col-md-5">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-bold text-muted small">Localidad</Form.Label>
                                                <Form.Control type="text" value={localidad} onChange={(e) => setLocalidad(e.target.value)} className="shadow-none" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-bold text-muted small">Provincia</Form.Label>
                                                <Form.Control type="text" value={provincia} onChange={(e) => setProvincia(e.target.value)} className="shadow-none" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-3">
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-bold text-muted small">CP</Form.Label>
                                                <Form.Control type="text" value={cp} onChange={(e) => setCp(e.target.value)} className="shadow-none" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <Form.Group className="mb-0">
                                        <Form.Label className="fw-bold">Observaciones</Form.Label>
                                        <Form.Control as="textarea" rows={3} value={observaciones} onChange={(e) => setObservaciones(e.target.value)} className="resize-none shadow-none" />
                                    </Form.Group>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card shadow-sm mb-0 border-0">
                        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center border-bottom">
                            <h5 className="mb-0 text-secondary">Familias del Proveedor</h5>
                            <Button variant="success" size="sm" onClick={agregarNuevaFamilia} className="rounded-pill px-3 shadow-sm d-flex align-items-center gap-2">
                                <FaPlus /> Nueva Familia
                            </Button>
                        </div>
                        <div className="card-body bg-white">
                            <div className="mb-3">
                                {familiasSeleccionadas.length > 0 ? (
                                    <div className="d-flex flex-wrap gap-2 mb-3 p-3 border rounded-3 bg-light" style={{ borderStyle: 'dashed' }}>
                                        {familiasSeleccionadas.map(fid => {
                                            const f = familiasDisponibles.find(fam => fam.id === fid);
                                            return f ? (
                                                <span key={fid} className="badge bg-primary text-white d-flex align-items-center gap-2 p-2 px-3 rounded-pill shadow-sm">
                                                    <small className="fw-bold">{f.nombre}</small>
                                                    <span
                                                        style={{ cursor: 'pointer', fontSize: '1.1rem', borderLeft: '1px solid rgba(255,255,255,0.3)', paddingLeft: '8px' }}
                                                        onClick={() => handleFamiliaChange(fid)}
                                                    >
                                                        &times;
                                                    </span>
                                                </span>
                                            ) : null;
                                        })}
                                    </div>
                                ) : (
                                    <div className="alert alert-light border py-3 mb-3 text-center" style={{ borderStyle: 'dashed' }}>
                                        <small className="text-muted">Ningúna familia seleccionada. Use el buscador debajo para agregar.</small>
                                    </div>
                                )}

                                <div className="input-group mb-3">
                                    <Form.Control
                                        type="text"
                                        placeholder="Buscar por nombre o código..."
                                        value={busquedaFamilia}
                                        onChange={(e) => setBusquedaFamilia(e.target.value)}
                                        className='buscador'
                                    />
                                </div>

                                <div className="border rounded-3 bg-white p-2" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                    {familiasFiltradas.length > 0 ? familiasFiltradas.map(f => (
                                        <div
                                            key={f.id}
                                            className={`d-flex justify-content-between align-items-center p-2 px-3 rounded-3 mb-1 transition-all ${familiasSeleccionadas.includes(f.id) ? 'bg-primary border-primary text-white shadow-sm' : 'hover-bg-light border-transparent text-dark'}`}
                                            onClick={() => handleFamiliaChange(f.id)}
                                            style={{ cursor: 'pointer', border: '1px solid' }}
                                        >
                                            <div className="d-flex align-items-center gap-3">
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={familiasSeleccionadas.includes(f.id)}
                                                    onChange={() => { }} // Controlled by div click
                                                    className="m-0 pointer-events-none"
                                                />
                                                <div>
                                                    <div className="fw-bold">{f.nombre}</div>
                                                    <small className={familiasSeleccionadas.includes(f.id) ? 'text-white-50' : 'text-muted'}>ID: {f.codigo}</small>
                                                </div>
                                            </div>
                                            {f.descripcion && <span className={`small opacity-75 d-none d-md-block`}><i>{f.descripcion.substring(0, 30)}...</i></span>}
                                        </div>
                                    )) : (
                                        <div className="text-center py-4 text-muted">
                                            <FaSearch size={24} className="mb-2 opacity-25" />
                                            <div>No se encontraron familias con "{busquedaFamilia}"</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-4 pb-2">
                        <Button variant="outline-secondary" onClick={onClose} className="px-4 rounded-3 border-secondary-subtle">Cancelar</Button>
                        <Button variant="primary" type="submit" className="px-4 fw-bold shadow-sm rounded-3 py-2">
                            {proveedorToEdit ? 'Actualizar Proveedor' : 'Registrar Proveedor'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ProveedorModal;
